import CardDefault from "components/Cards/CardDefault";
import { Flex, Text } from "@chakra-ui/react";
import { DashboardManutencao } from "core/features/manutencao/typings";
import moment from "moment";
import { useRegrasTenant } from "core/features/tenants/tenants.context";

interface ProximasManutencoesProps {
  data: DashboardManutencao | undefined;
}

export default function ProximasManutencoes({
  data,
}: ProximasManutencoesProps) {
  const { useSubtenantsViews } = useRegrasTenant();

  return (
    <CardDefault>
      <Text fontWeight="bold" mb={2}>
        Próximas manutenções:
      </Text>
      <Flex flexDirection="column" h="160px" overflowY="auto" pr={4}>
        {data?.proximas?.map((v) => (
          <Flex
            flexDirection="column"
            key={v.id}
            py={1}
            borderBottomColor="gray.500"
            borderBottomWidth={1}
          >
            <Text>
              <Text fontWeight="bold"> {moment(v.data).format("DD/MM")}</Text>
              {v.equipamentos}
            </Text>
            {useSubtenantsViews && v.tenant ? (
              <Text fontWeight="bold" fontSize={10} mb={1} color="gray.500">
                {v.tenant.nome}
              </Text>
            ) : null}
            <Text fontWeight="medium" fontSize={12}>
              {v.planoManutencao}
            </Text>
          </Flex>
        ))}
      </Flex>
    </CardDefault>
  );
}
